'use client';

import { PERMISSIONS } from '@terra/shared-authorization';
import { AI_CAPACITY_LICENSE_ENABLED_FLAG } from '@terra/shared-contracts-feature-flags';
import { ApplicationScanEffortCard, Button } from '@terra/ui-design-system';
import {
  useApplicationScanEffort,
  useUpdateApplicationScanEffort,
} from '../../../hooks/api/useApplicationScanEffort';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';
import { useOpenWebAppPage } from '../../../hooks/useOpenWebAppPage';
import { usePermissions } from '../../../hooks/usePermissions';
import { WEB_APP_PATHS } from '../../../utils/webAppPaths';

type TargetScanEffortCardProps = {
  applicationId: string;
  isReadOnly?: boolean;
};

export function TargetScanEffortCard({
  applicationId,
  isReadOnly,
}: TargetScanEffortCardProps) {
  const { isFeatureFlagEnabled } = useFeatureFlags(
    AI_CAPACITY_LICENSE_ENABLED_FLAG,
  );
  const { hasPermission } = usePermissions();
  const openWebAppPage = useOpenWebAppPage();
  const { data } = useApplicationScanEffort({
    applicationId,
    enabled: isFeatureFlagEnabled,
  });
  const updateMutation = useUpdateApplicationScanEffort({ applicationId });

  if (!isFeatureFlagEnabled) {
    return null;
  }

  return (
    <ApplicationScanEffortCard
      scanEffort={data}
      canManage={
        hasPermission(PERMISSIONS.MANAGE_AI_CAPACITY.name) && !isReadOnly
      }
      isUpdating={updateMutation.isPending}
      onUpdate={updateMutation.mutateAsync}
      renderTenantOverrideLink={(label) => (
        <Button
          variant="link"
          size="sm"
          p={0}
          h="auto"
          minH={0}
          onClick={() => openWebAppPage(WEB_APP_PATHS.licenseUsage)}
        >
          {label}
        </Button>
      )}
    />
  );
}
